<se-fe-page
  seFeDataWidth="full"
  [seFeDataLoaded]="ready">
  <se-fe-header seFePageHeader seFeDataSize="750" [seFeDataTitle]="displayHeader ? 'Household' : ''">
    <se-fe-button
      seFeDataEmphasis="high"
      seFeHeaderActions
      (click)="onPersonaCreate()">
      <se-fe-icon
        seFeDataColor="white"
        seFeIconBefore
        seFeDataName="plus"
        seFeDataSize="500">
      </se-fe-icon>
      Add Person
    </se-fe-button>
  </se-fe-header>
  <div seFePageContent>
    @if (ready) {
      <div class="household-avatars">
        <se-po-duplicate-banner [profiles]="profiles" (nudge)="onMerge($event, 'from_nudge')" (merge)="onMerge($event, 'from_banner')">
        </se-po-duplicate-banner>
        @if (selfProfile) {
          <div class="household-avatar">
            <se-po-household-avatar
              seFeSidePanelTrigger
              [profile]="selfProfile"
              (chosen)="onChosen($event)"
              (remove)="onRemove($event)">
            </se-po-household-avatar>
          </div>
        }
        @if (childProfiles.length) {
          <div class="household-subheading">
            Children
            <button type="button" [seFePopoverTrigger]="childrenHouseholdPopover" class="household-popover">
              <se-fe-icon
                seFeDataName="info_circle"
                seFeDataSize="500"
                seFeDataColor="gray-700">
              </se-fe-icon>
            </button>
            <se-fe-popover #childrenHouseholdPopover>
              Profiles under the age of 18.
            </se-fe-popover>
          </div>
        }
        @for (profile of childProfiles; track profile) {
          <div class="household-avatar">
            <se-po-household-avatar
              seFeSidePanelTrigger
              [profile]="profile"
              [profiles]="childProfiles"
              (chosen)="onChosen($event)"
              (merge)="onMerge($event, 'from_profile_card')"
              (remove)="onRemove($event)">
            </se-po-household-avatar>
          </div>
        }
        @if (adultProfiles.length || managerGuardians.length) {
          <div class="household-subheading">
            Adults
            <button type="button" [seFePopoverTrigger]="adultsHouseholdPopover" class="household-popover">
              <se-fe-icon
                seFeDataName="info_circle"
                seFeDataSize="500"
                seFeDataColor="gray-700">
              </se-fe-icon>
            </button>
            <se-fe-popover #adultsHouseholdPopover>
              Profiles over the age of 18.
            </se-fe-popover>
          </div>
        }
        @for (profile of adultProfiles; track profile) {
          <div class="household-avatar">
            <se-po-household-avatar
              seFeSidePanelTrigger
              [profile]="profile"
              (chosen)="onChosen($event)"
              (remove)="onRemove($event)">
            </se-po-household-avatar>
          </div>
        }
        @for (guardian of managerGuardians; track guardian) {
          <div class="household-avatar">
            <se-po-household-avatar
              seFeSidePanelTrigger
              [profile]="guardian"
              (chosen)="onChosen($event)"
              (remove)="onRemove($event)">
            </se-po-household-avatar>
          </div>
        }
      </div>
    }
    <se-po-household-side-panel #householdSidePanel
      [(personaId)]="selectedPersonaId"
      [guardians]="allGuardians"
      [profiles]="profiles"
      (edit)="onEdit($event)"
      (guardianUpdate)="onGuardianUpdate($event)"
      (merge)="onMerge($event, 'from_side_panel')"
      (personaEdited)="onPersonaEdit($event)"
      (profileRemove)="onRemove($event)">
    </se-po-household-side-panel>
  </div>
</se-fe-page>
<se-po-edit-persona-modal #editPersonaModal
  seFeSidePanelTrigger
  (personaEdited)="onPersonaEdit($event)">
</se-po-edit-persona-modal>
<se-po-remove-persona-modal #removePersonaModal
  seFeSidePanelTrigger
  (personaRemoved)="onPersonaRemove($event)">
</se-po-remove-persona-modal>
<se-po-merge-persona-modal #mergePersonaModal
  seFeSidePanelTrigger
  (personaMerged)="onPersonaRemove($event)">
</se-po-merge-persona-modal>
<se-po-new-person-modal #newPersonModal
  [profiles]="profiles"
  [guardians]="allGuardians"
  (childAdded)="getHousehold()">
</se-po-new-person-modal>
<se-po-new-guardian-modal #newGuardianModal
  (modalClosed)="onNewGuardianModalClose()">
</se-po-new-guardian-modal>
